var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',[_c('span',{staticClass:"mr-1"},[(_vm.isExpanded)?_c('font-awesome-icon',{attrs:{"icon":['fas', 'angle-down']}}):_c('font-awesome-icon',{attrs:{"icon":['fas', 'angle-right']}})],1),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }